module.exports = __webpack_public_path__ + "img/keralis-75094129-2caf-4830-d662-08d957755ecc.png";